package com.anjuros.website.templates.template9.sections

import com.anjuros.website.templates.template9.components.Template9Reveal
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.selection.components.contactform.ContactForm
import com.anjuros.website.templates.selection.components.contactform.EMAIL_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.MESSAGE_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.NAME_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.PHONE_NUMBER_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.SuccessContactMessage
import com.anjuros.website.templates.template9.components.Template9Eyebrow
import com.anjuros.website.templates.template9.components.Template9PrimaryButton
import com.anjuros.website.templates.template9.components.Template9Sparks
import com.anjuros.website.templates.template9.components.Template9Squiggle
import com.anjuros.website.templates.template9.modules.Template9Section
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.modules.getColor
import com.anjuros.website.templates.template9.modules.getColorHex
import com.anjuros.website.templates.template9.styles.TEMPLATE9_BLOB_CTA
import com.anjuros.website.templates.template9.styles.Template9CTAImageStyle
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9FormWidthStyle
import com.anjuros.website.templates.template9.styles.Template9SectionTitleStyle
import com.anjuros.website.templates.template9.styles.template9Blob
import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Constants
import com.anjuros.website.templates.template9.util.Template9Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private const val CONTACT_FORM_ID = "contactform"

/**
 * “Ready to Book?” call-to-action banner.
 * When [showContactForm] is true a contact form card is shown above the banner
 * and the banner button scrolls to it; otherwise the button calls the business.
 */
@Composable
fun Template9ContactSection(showContactForm: Boolean = false) {
    Column(
        modifier = Modifier
            .id(Template9Section.Contact.id)
            .fillMaxWidth()
            .backgroundColor(Template9Theme.Background.rgb)
            .padding(top = 30.px, bottom = 60.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (showContactForm) {
            Column(
                modifier = Template9ContainerStyle.toModifier()
                    .id(CONTACT_FORM_ID)
                    .margin(bottom = 70.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Template9Eyebrow(text = ResKey.TEMPLATE9_SECTION5)
                P(
                    attrs = Template9SectionTitleStyle.toModifier()
                        .margin(top = 12.px, bottom = 6.px)
                        .fontFamily(Template9Constants.HEADING_FONT_FAMILY, Template9Constants.FONT_FAMILY)
                        .fontWeight(FontWeight.Bold)
                        .textAlign(TextAlign.Center)
                        .color(Template9Theme.Secondary.rgb)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.TEMPLATE9_CONTACT_CARD_TITLE))
                }
                Template9Squiggle(color = Template9Theme.Primary.getColorHex())
                Template9Reveal(
                    modifier = Template9FormWidthStyle.toModifier().margin(top = 36.px),
                    delayMs = 100
                ) {
                    Template9ContactBox(modifier = Modifier.fillMaxWidth())
                }
            }
        }

        Template9Reveal(
            modifier = Template9ContainerStyle.toModifier(),
            contentAlignment = Alignment.Center
        ) {
            Template9CTABanner(
                modifier = Modifier.fillMaxWidth(),
                buttonPath = if (showContactForm) "#$CONTACT_FORM_ID" else "tel:${Template9Constants.CLIENTS_PHONE}"
            )
        }
    }
}

@Composable
fun Template9ContactBox(
    modifier: Modifier = Template9FormWidthStyle.toModifier()
) {
    var success by remember { mutableStateOf(false) }

    Box(
        modifier = modifier
            .padding(30.px)
            .position(Position.Relative)
            .backgroundColor(Colors.White)
            .border(width = 1.px, style = LineStyle.Solid, color = Template9Theme.Border.rgb)
            .borderRadius(24.px)
            .boxShadow(offsetY = 10.px, blurRadius = 30.px, color = rgba(27, 33, 66, 0.08)),
        contentAlignment = Alignment.Center
    ) {
        ContactForm(
            isDemo = true,
            buttonColor = Template9Theme.Primary.getColor(),
            contactItemsList = listOf(
                NAME_CONTACT_FORM.copy(index = 0),
                EMAIL_CONTACT_FORM.copy(index = 1),
                PHONE_NUMBER_CONTACT_FORM.copy(index = 2),
                MESSAGE_CONTACT_FORM.copy(index = 3),
            )
        ) {
            success = true
        }
        SuccessContactMessage(
            isDemo = true,
            showSuccess = success,
            onClose = { success = false }
        )
    }
}

@Composable
private fun Template9CTABanner(
    modifier: Modifier = Template9ContainerStyle.toModifier(),
    buttonPath: String
) {
    Box(
        modifier = modifier
            .backgroundColor(Template9Theme.Accent.rgb)
            .borderRadius(40.px)
            .padding(leftRight = 30.px, topBottom = 30.px)
    ) {
        Template9Sparks(
            modifier = Modifier
                .align(Alignment.TopEnd)
                .margin(top = 10.px, right = 16.px),
            color = "#FFFFFF"
        )

        // Desktop: image | text | button in one row
        Row(
            modifier = Modifier
                .displayIfAtLeast(Breakpoint.MD)
                .fillMaxWidth()
                .gap(30.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Row(
                modifier = Modifier.gap(30.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Template9CTAImage()
                Template9CTAText(alignment = Alignment.Start)
            }
            Template9PrimaryButton(
                modifier = Modifier.flexShrink(0),
                text = ResKey.TEMPLATE9_BUTTON_BOOK,
                path = buttonPath,
                backgroundColor = Template9Theme.Secondary.rgb
            )
        }

        // Mobile: stacked and centred
        Column(
            modifier = Modifier
                .displayUntil(Breakpoint.MD)
                .fillMaxWidth()
                .gap(20.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Template9CTAImage()
            Template9CTAText(alignment = Alignment.CenterHorizontally)
            Template9PrimaryButton(
                text = ResKey.TEMPLATE9_BUTTON_BOOK,
                path = buttonPath,
                backgroundColor = Template9Theme.Secondary.rgb
            )
        }
    }
}

@Composable
private fun Template9CTAImage() {
    Box(
        modifier = Template9CTAImageStyle.toModifier()
            .flexShrink(0)
            .template9Blob(TEMPLATE9_BLOB_CTA)
            .overflow(Overflow.Hidden)
            .border(width = 5.px, style = LineStyle.Solid, color = Colors.White)
    ) {
        AnjurosImage(
            modifier = Modifier
                .fillMaxSize()
                .objectFit(ObjectFit.Cover),
            src = Template9Res.Image.cta,
            alt = "Book a dog walk today"
        )
    }
}

@Composable
private fun Template9CTAText(alignment: Alignment.Horizontal) {
    Column(horizontalAlignment = alignment) {
        P(
            attrs = Template9SectionTitleStyle.toModifier()
                .margin(0.px)
                .fontFamily(Template9Constants.HEADING_FONT_FAMILY, Template9Constants.FONT_FAMILY)
                .fontWeight(FontWeight.Bold)
                .textAlign(if (alignment == Alignment.Start) TextAlign.Start else TextAlign.Center)
                .color(Template9Theme.Secondary.rgb)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE9_CONTACT_TITLE))
        }
        P(
            attrs = Modifier
                .maxWidth(340.px)
                .margin(top = 10.px, bottom = 0.px)
                .fontFamily(Template9Constants.FONT_FAMILY)
                .fontSize(15.px)
                .lineHeight(1.6)
                .textAlign(if (alignment == Alignment.Start) TextAlign.Start else TextAlign.Center)
                .color(Template9Theme.Secondary.rgb)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE9_CONTACT_SUBTITLE))
        }
    }
}
